export default "__VITE_ASSET__BdndVWYu__"